"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationRendererEntry = exports.CommonControlsSectionHeader = exports.LayoutControlsPanel = exports.ApplicationRendererSection = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSL_1 = require("./ViewSL");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var ApplicationRendererEntry_1 = require("../ApplicationRendererEntry/ApplicationRendererEntry");
Object.defineProperty(exports, "ApplicationRendererEntry", { enumerable: true, get: function () { return ApplicationRendererEntry_1.ApplicationRendererEntry; } });
var ApplicationRendererSection = (function (_super) {
    __extends(ApplicationRendererSection, _super);
    function ApplicationRendererSection(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSL = ViewSL_1.viewSL.apply(_this);
        _this.viewSL.constructor && _this.viewSL.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationRendererSection.prototype.componentDidMount = function () {
        this.viewSL.mounted && this.viewSL.mounted.apply(this, arguments);
    };
    ApplicationRendererSection.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSL.shouldUpdate)
            return this.viewSL.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationRendererSection.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSL.didUpdate && this.viewSL.didUpdate.apply(this, arguments);
    };
    ApplicationRendererSection.prototype.componentWillUnmount = function () {
        this.viewSL.unmount && this.viewSL.unmount.apply(this, arguments);
    };
    ApplicationRendererSection.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationRendererSection.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationRendererSection.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSL.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSL.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationRendererSection.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            var section_handler = function () {
                var section_result = _this.props.sections.map(function (section, section$index) {
                    var keyPrefix = undefined;
                    return [
                        React.createElement(Panel_1.Panel, { key: section$index.toString() + 0, paddingVertical: "Medium", children: [
                                React.createElement(Panel_1.Panel, { key: section$index.toString() + 0, paddingBottom: "Small", children: [
                                        React.createElement(SectionHeader_1.SectionHeader, { key: section$index.toString() + 0, size: "H2", text: section.title })
                                    ] }),
                                React.createElement(ApplicationRendererEntry_1.ApplicationRendererEntry, { key: section$index.toString() + 1, entries: section.entries, addEntryText: section.addEntryText, deleteEntryText: section.deleteEntryText, sectionId: section.sectionId, minimumEntries: section.minimumEntries, onChange: _this._proxyEvent("onChange", section, section$index, "repeaterArgs"), onChangeNoId: _this._proxyEvent("onChangeNoId", section, section$index, "repeaterArgs"), onChangeDate: _this._proxyEvent("onChangeDate", section, section$index, "repeaterArgs"), onChangeDaterange: _this._proxyEvent("onChangeDaterange", section, section$index, "repeaterArgs"), onAddEntry: _this._proxyEvent("onAddEntry", section, section$index, "repeaterArgs"), onEntryDeleted: _this._proxyEvent("onEntryDeleted", section, section$index, "repeaterArgs") })
                            ] })
                    ];
                });
                return section_result;
            };
            return [
                section_handler()
            ];
        };
        return root_handler();
    };
    ApplicationRendererSection.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSL-applicationrenderersection" }, this._renderView()));
    };
    ApplicationRendererSection.defaultProps = {
        sections: [],
        onChange: function () { }, onChangeNoId: function () { }, onChangeDate: function () { }, onChangeDaterange: function () { }, onAddEntry: function () { }, onEntryDeleted: function () { }
    };
    return ApplicationRendererSection;
}(React.Component));
exports.ApplicationRendererSection = ApplicationRendererSection;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationRendererSection"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationRendererSection/ApplicationRendererSection.js
// module id = 377
// module chunks = 0 1